import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';

export type ConfirmationModalButtonStyle = 'primary' | 'secondary' | 'danger' | 'link';

export type ConfirmationModalButton<T extends string = string> = {
  action: T;
  label: string;
  style: ConfirmationModalButtonStyle;
};

export type ConfirmationModalConfig<T extends string = string> = {
  title: string;
  message: string;
  buttons: ConfirmationModalButton<T>[];
};

@Component({
  selector: 'app-confirmation-modal',
  imports: [TranslateModule, UpperFirstLetterPipe],
  templateUrl: './confirmation-modal.html',
  styleUrl: './confirmation-modal.scss',
})
export class ConfirmationModal {
  private dialogRef: DialogRef<string> = inject(DialogRef<string>);

  readonly title: InputSignal<string> = input.required<string>();
  readonly message: InputSignal<string> = input.required<string>();
  readonly buttons: InputSignal<ConfirmationModalButton[]> =
    input.required<ConfirmationModalButton[]>();

  readonly linkButtons: Signal<ConfirmationModalButton[]> = computed(() =>
    this.buttons().filter((button: ConfirmationModalButton) => button.style === 'link'),
  );
  readonly actionButtons: Signal<ConfirmationModalButton[]> = computed(() =>
    this.buttons().filter((button: ConfirmationModalButton) => button.style !== 'link'),
  );

  close(action: string): void {
    this.dialogRef.close(action);
  }
}
